import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLoaderData, useLocation } from 'react-router-dom';
import { Container, Grid, Card, CardContent, Typography, Box, Avatar, TextField, Button, Input, MenuItem, Select, InputLabel, FormHelperText, FormControl, Snackbar, Alert, IconButton, Chip, Skeleton } from '@mui/material';
import { styled } from '@mui/system';
import { Edit, Save, AccountBalance, School, FileUpload, Email, Phone, Info, Language, Home, CalendarToday, LocationOn, Person, Lock, Delete, CheckCircle, Facebook, Instagram, Twitter, LinkedIn, YouTube, X } from '@mui/icons-material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Header1 from '../Header/Header1';
import Header3 from '../Header/Header3';
import Footer from '../Footer/Footer';
import { Link as MuiLink } from '@mui/material';
import GenderIcon from '@mui/icons-material/Male';
import { Link } from 'react-router-dom';
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import RecommendationSetup from '../Recommendations/RecommendationSetup';
import avatar from './default-avatar.png'
import { MonetizationOn, PostAdd, Event } from '@mui/icons-material';
import YouTubeEmbed from '../UserProfile/YouTubeEmbed';



const API_URL = process.env.REACT_APP_API_URL;




const theme = createTheme({
  palette: {
    primary: {
      main: '#1111',
    },
    secondary: {
      main: '#1111',
    },
    background: {
      paper: '#1111',
    },
  },
});






const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  marginBottom: theme.spacing(2),

}));




function PublicViewUser({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const { id } = useParams();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };




  const navigate = useNavigate();


  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [userData, setUserData] = useState({
    "name": "",
    "about": "",
    "contact": "",
    "address": "",
    "created_at": "",
    "dob": "",
    "email": "",
    "gender": "",
    "id": "",
    "image": "",
    "languages": "",
    "password": "",
    "rating": "",
    "role": "",
    "status": "",
    "surname": "",
    "city": "",
    "state": "",
    "country": "",
    "pincode": "",
    "updated_at": "",
    "facebook": "",
    "instagram": "",
    "x": "",
    "linkedin": "",
    "youtube": "",
    "currentLevel": "Advanced",
    "totalTimeLearning": "150 hrs",
    "totalTimeTeaching": "50 hrs",
    "totalSessions": "25",
    "ratings": "4.8/5",
  });

  const [image, setImage] = useState(null);
  const [error, setError] = useState('');




  useEffect(() => {
    if (!userId) {
      return;
    }

    axios
      .get(`${API_URL}/get_user_data/?user_id=${id}`)
      .then((response) => {
        setUserData(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [userId]);










  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };





  const [openSnackbar, setOpenSnackbar] = useState(false);


  const handleChange = (e, name) => {
    setUserData({
      ...userData,
      [name]: e.target.value
    });
  };



  const [isEditing, setIsEditing] = useState(false);









  return (
    <div>
      <Header1 userId={userId} onLogout={onLogout} />
      <Typography
        variant="h3"
        component="h1"
        align="center"
        fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
        sx={{
          backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
          mt: 10,
          letterSpacing: 10,
          WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
          color: 'transparent',  // Makes the text itself transparent to show the gradient
        }}
        gutterBottom
      >
        User View
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          minHeight: '100vh',
          backgroundColor: 'black',
          padding: 2,  // Add padding for spacing
          gap: 2,      // Add space between items in the column
          justifyContent: 'flex-start',
          alignItems: 'center',  // Center items horizontally in smaller screens
          width: '100%',  // Make sure it spans the full width of the screen
          '@media (min-width: 600px)': {
            flexDirection: 'row', // On larger screens, switch to row layout
            justifyContent: 'space-evenly', // Distribute space evenly between items
            alignItems: 'center', // Align items centrally along the row
          },
          '@media (min-width: 1024px)': {
            padding: 4, // Increase padding on larger screens
            gap: 3,     // Increase the gap for a more spacious layout
          },
        }}
      >


        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          lg={2}
          sx={{
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',  // Centers content horizontally
            alignItems: 'center'       // Centers content vertically
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' }, // Column on small screens, row on medium and up
              flexWrap: 'wrap', // Allow links to wrap if needed
              gap: 2, // Space between links
              backgroundColor: '#1111',
              alignItems: 'center',
              justifyContent: 'center',
              padding: { xs: 1, sm: 2, md: 3 }, // Adjust padding based on screen size
              borderRadius: 2,
              boxShadow: 2,
              borderColor: '#5555',
              "&:hover": {
                transform: "translateY(-3px)",
                borderColor: '#1E90FF',
                boxShadow: "0 10px 20px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 1,
              flexWrap: 'wrap',
              justifyContent: { xs: 'center', sm: 'center' }, // Center content for small screens
              alignItems: { xs: 'center', sm: 'center' } // Center content vertically for small screens
            }}>



              <MuiLink
                href="#role"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 1,
                  borderRadius: 1,
                  color: '#f5f5f5',
                  letterSpacing: 3,
                  textDecoration: 'none',
                  '&:hover': {
                    backgroundColor: '#2222',
                    color: '#1E90FF',
                  },
                }}
              >
                Role
              </MuiLink>

              <MuiLink
                href="#about"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 1,
                  borderRadius: 1,
                  letterSpacing: 3,
                  color: '#f5f5f5',
                  textDecoration: 'none',
                  '&:hover': {
                    backgroundColor: '#2222',
                    color: '#1E90FF',
                  },
                }}
              >
                About
              </MuiLink>



              <MuiLink
                href="#Experience"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 1,
                  borderRadius: 1,
                  letterSpacing: 3,
                  color: '#f5f5f5',
                  textDecoration: 'none',
                  '&:hover': {
                    backgroundColor: '#2222',
                    color: '#1E90FF',
                  },
                }}
              >
                Experience
              </MuiLink>
              <MuiLink
                href="#Passion"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 1,
                  borderRadius: 1,
                  letterSpacing: 3,
                  color: '#f5f5f5',
                  textDecoration: 'none',
                  '&:hover': {
                    backgroundColor: '#2222',
                    color: '#1E90FF',
                  },
                }}
              >
                Passion
              </MuiLink>
              <MuiLink
                href="#availability"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 1,
                  borderRadius: 1,
                  letterSpacing: 3,
                  color: '#f5f5f5',
                  textDecoration: 'none',
                  '&:hover': {
                    backgroundColor: '#2222',
                    color: '#1E90FF',
                  },
                }}
              >
                Availability
              </MuiLink>
              <MuiLink
                href="#languages-known"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 1,
                  borderRadius: 1,
                  letterSpacing: 3,
                  color: '#f5f5f5',
                  textDecoration: 'none',
                  '&:hover': {
                    backgroundColor: '#2222',
                    color: '#1E90FF',
                  },
                }}
              >
                Languages
              </MuiLink>
              <MuiLink
                href="#areas_of_interest"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 1,
                  borderRadius: 1,
                  letterSpacing: 3,
                  color: '#f5f5f5',
                  textDecoration: 'none',
                  '&:hover': {
                    backgroundColor: '#2222',
                    color: '#1E90FF',
                  },
                }}
              >
                Interests
              </MuiLink>






            </Box>
          </Box>
        </Grid>



        <ThemeProvider theme={theme}>
          <Container
            maxWidth="lg"
            sx={{
              marginTop: 10,
              mb: 10,
              display: 'flex',
              justifyContent: 'center',  // Centers content horizontally
              alignItems: 'center',      // Centers content vertically
              flexDirection: 'column'    // Ensures that the items are stacked vertically
            }}
          >
            <Grid container spacing={4} justifyContent="center" alignItems={'center'}>


              <Grid
                item
                xs={15}
                sm={10}
                md={8}
                lg={8}    // Custom size for large screens
                xl={10}    // Custom size for extra-large screens
                xxl={10}   // Custom size for even larger screens (if needed)
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>




                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>




                    <Avatar sx={{
                      width: 150,
                      height: 150,
                    }} src={`${API_URL}${userData.image}` || '/default-avatar.png'} alt={userData.name || 'User'} />


                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', mt: 2 }}>


                      {userData.linkedin && (
                        <a href={userData.linkedin} target="_blank" rel="noopener noreferrer">
                          <IconButton sx={{
                            color: 'white',
                            marginBottom: { xs: 0.5, sm: 1 }, // Responsive margin bottom
                            '&:hover': { color: '#1E90FF' }
                          }}>
                            <LinkedIn sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' } }} />
                          </IconButton>
                        </a>
                      )}



                    </Box>



                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', mb: 5 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', mb: 5, mt: 3 }}>
                        <Typography
                          variant="h4"
                          color="white"
                          sx={{
                            fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem', lg: '2rem' }, // Adjust font size for different screen sizes
                            display: 'flex',  // Use flexbox to arrange the name and surname in a row
                            alignItems: 'center', // Vertically align the text
                            letterSpacing: 7,
                          }}
                        >
                          <span>{userData.name}</span>
                          <span style={{ marginLeft: '10px' }}>{userData.surname}</span>
                        </Typography>

                      </Box>




                    </Box>

                  </Box>
                </Box>







                {userData.youtube && (
                  <div>
                    <YouTubeEmbed
                      videoUrl={userData.youtube}
                      title="Sample YouTube Video"
                    />
                  </div>
                )}


                <Box
                  id="role"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 4,
                    backgroundColor: '#000000',  // Dark background for modern look
                    borderRadius: 2,
                    boxShadow: 3,  // Add shadow for depth
                    maxWidth: '800px', // Limit the width for large screens
                    margin: '0 auto',  // Center on the page
                    marginTop: 10,  // Add top margin for space
                    textAlign: 'center', // Center the text
                    width: '100%',  // Make it responsive
                    border: '1px solid #ddd',// Add a white border
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <SectionTitle sx={{ color: 'white', marginBottom: 2, letterSpacing: 3 }}>Current Role</SectionTitle>

                    {userData.facebook && (

                      <Typography variant="body2" sx={{ marginTop: '1rem', color: '#b0bec5', letterSpacing: 3 }}>
                        {userData.facebook || 'No description available'}
                      </Typography>
                    )}

                  </Box>
                </Box>


                {/* About you Card */}
                <Box
                  id="about"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 4,
                    backgroundColor: '#000000',  // Dark background for modern look
                    borderRadius: 2,
                    boxShadow: 3,  // Add shadow for depth
                    maxWidth: '800px', // Limit the width for large screens
                    margin: '0 auto',  // Center on the page
                    marginTop: 10,  // Add top margin for space
                    textAlign: 'center', // Center the text
                    width: '100%',  // Make it responsive
                    border: '1px solid #ddd',// Add a white border
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <SectionTitle sx={{ color: 'white', marginBottom: 2, letterSpacing: 3 }}>About</SectionTitle>

                    {userData.about && (

                      <Typography variant="body2" sx={{ marginTop: '1rem', color: '#b0bec5', letterSpacing: 3 }}>
                        {userData.about || 'No description available'}
                      </Typography>
                    )}

                  </Box>
                </Box>


                {/* Experience and Background Card */}
                <Box
                  id="Experience"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 4,
                    backgroundColor: '#000000',  // Dark background for modern look
                    borderRadius: 2,
                    boxShadow: 3,  // Add shadow for depth
                    maxWidth: '800px', // Limit the width for large screens
                    margin: '0 auto',  // Center on the page
                    marginTop: 10,  // Add top margin for space
                    textAlign: 'center', // Center the text
                    width: '100%',  // Make it responsive
                    border: '1px solid #ddd',// Add a white border
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <SectionTitle sx={{ color: 'white', marginBottom: 2, letterSpacing: 3 }}>Experience and Background</SectionTitle>

                    {/* Conditionally render helper text */}
                    {userData.instagram && (

                      <Typography variant="body2" sx={{ marginTop: '1rem', color: '#b0bec5', letterSpacing: 3 }}>
                        {userData.instagram || 'No description available'}
                      </Typography>
                    )}

                  </Box>
                </Box>

                {/* Passion and Interests Card */}
                <Box
                  id="Passion"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 4,
                    backgroundColor: '#000000',  // Dark background for modern look
                    borderRadius: 2,
                    boxShadow: 3,  // Add shadow for depth
                    maxWidth: '800px', // Limit the width for large screens
                    margin: '0 auto',  // Center on the page
                    marginTop: 10,  // Add top margin for space
                    textAlign: 'center', // Center the text
                    width: '100%',  // Make it responsive
                    border: '1px solid #ddd',// Add a white border
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <SectionTitle sx={{ color: 'white', marginBottom: 2, letterSpacing: 3 }}>Passion and Interests</SectionTitle>

                    {/* Conditionally render helper text */}
                    {userData.x && (

                      <Typography variant="body2" sx={{ marginTop: '1rem', color: '#b0bec5', letterSpacing: 3 }}>
                        {userData.x || 'No description available'}
                      </Typography>
                    )}


                  </Box>
                </Box>



                {/* Time of Availability  */}
                <Box
                  id="availability"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 4,
                    backgroundColor: '#000000',  // Dark background for modern look
                    borderRadius: 2,
                    boxShadow: 3,  // Add shadow for depth
                    maxWidth: '800px', // Limit the width for large screens
                    margin: '0 auto',  // Center on the page
                    marginTop: 10,  // Add top margin for space
                    textAlign: 'center', // Center the text
                    width: '100%',  // Make it responsive
                    border: '1px solid #ddd',// Add a white border
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <SectionTitle sx={{ color: 'white', marginBottom: 2, letterSpacing: 3 }}>Time of Availability</SectionTitle>

                    {/* Conditionally render helper text */}
                    {userData.Experience && (

                      <Typography variant="body2" sx={{ marginTop: '1rem', color: '#b0bec5', letterSpacing: 3 }}>
                        {userData.Experience || 'N/A'}
                      </Typography>
                    )}


                  </Box>
                </Box>



                {/* Languages Known */}
                <Box
                  id="languages-known"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 4,
                    backgroundColor: '#000000',  // Dark background for modern look
                    borderRadius: 2,
                    boxShadow: 3,  // Add shadow for depth
                    maxWidth: '800px', // Limit the width for large screens
                    margin: '0 auto',  // Center on the page
                    marginTop: 10,  // Add top margin for space
                    textAlign: 'center', // Center the text
                    width: '100%',  // Make it responsive
                    border: '1px solid #ddd',// Add a white border
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <SectionTitle sx={{ color: 'white', marginBottom: 2, letterSpacing: 3 }}>Languages known</SectionTitle>

                    {/* Conditionally render helper text */}
                    {userData.languages && (



                      <Typography variant="body2" sx={{ marginTop: '1rem', color: '#b0bec5', letterSpacing: 3 }}>
                        {userData.languages || 'N/A'}
                      </Typography>
                    )}


                  </Box>
                </Box>



                {/* Areas of Interests */}
                <Box
                  id="areas_of_interest"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 4,
                    backgroundColor: '#000000',  // Dark background for modern look
                    borderRadius: 2,
                    boxShadow: 3,  // Add shadow for depth
                    maxWidth: '800px', // Limit the width for large screens
                    margin: '0 auto',  // Center on the page
                    marginTop: 10,  // Add top margin for space
                    textAlign: 'center', // Center the text
                    width: '100%',  // Make it responsive
                    border: '1px solid #ddd',// Add a white border
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <SectionTitle sx={{ color: 'white', marginBottom: 2, letterSpacing: 3 }}>Areas of Interests</SectionTitle>

                    {userData.areas_of_interest && (


                      <Typography variant="body2" sx={{ marginTop: '1rem', color: '#b0bec5', letterSpacing: 3 }}>
                        {userData.areas_of_interest && userData.areas_of_interest.length > 0
                          ? userData.areas_of_interest.join(', ')  // If it's a list, display them as comma-separated values
                          : 'N/A'}
                      </Typography>
                    )}


                  </Box>
                </Box>

















              </Grid>
            </Grid>
          </Container>
        </ThemeProvider>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={() => setOpenSnackbar(false)}
        >
          <Alert severity="success" sx={{ width: '100%', letterSpacing: 3 }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
      <IconButton
        onClick={scrollToTop}
        sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black', letterSpacing: 3 }}>
        <ArrowUpwardIcon />
      </IconButton>
      <Footer2 />
    </div>

  );
}

export default PublicViewUser;